import { render, staticRenderFns } from "./CancelSubscription.vue?vue&type=template&id=dd5d5b62&scoped=true&"
import script from "./CancelSubscription.vue?vue&type=script&lang=js&"
export * from "./CancelSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5d5b62",
  null
  
)

export default component.exports